/**
 * @generated SignedSource<<ff084074838c5f02f9d5ff28fd9c88e9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type TripPricesCardMutation$variables = {};
export type TripPricesCardMutation$data = {
  readonly recalculateTripPrices: boolean;
};
export type TripPricesCardMutation = {
  response: TripPricesCardMutation$data;
  variables: TripPricesCardMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "recalculateTripPrices",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "TripPricesCardMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "TripPricesCardMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "84d32c054f186a5356438098abe2cfba",
    "id": null,
    "metadata": {},
    "name": "TripPricesCardMutation",
    "operationKind": "mutation",
    "text": "mutation TripPricesCardMutation {\n  recalculateTripPrices\n}\n"
  }
};
})();

(node as any).hash = "b3c54603a9c46ec7c846fe96dcacace0";

export default node;
